import React, { useMemo } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { GroupBase } from "react-select";
import {
  ReactSelectSyncProps,
  ReactSelectAsyncProps,
  ReactSelectController,
  ReactSelectControllerProps,
} from "@pushpress/shared-components";
import { useAppointmentDiscountsQuery } from "../../../apis/appointmentApi.hooks";

interface Value {
  uuid: string;
  name: string;
}

type AppointmentDiscountSelectProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  Option extends Value,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = ReactSelectControllerProps<TFieldValues, TName, Option, IsMulti, Group>;

function AppointmentDiscountSelect<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
  Option extends Value,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: AppointmentDiscountSelectProps<
    TFieldValues,
    TName,
    Option,
    IsMulti,
    Group
  > &
    (ReactSelectSyncProps | ReactSelectAsyncProps),
) {
  const { ...other } = props;

  const { data } = useAppointmentDiscountsQuery({
    staleTime: Infinity,
  });

  const getOptionLabel = (option: Value) => {
    return option.name;
  };

  const getOptionValue = (option: Value) => {
    return option.uuid;
  };

  const options = useMemo<Value[]>(() => {
    return data?.data || [];
  }, [data]);

  return (
    <ReactSelectController
      menuPortalTarget={document.body}
      {...other}
      options={options}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
    />
  );
}

export default AppointmentDiscountSelect;
